// Persistent per-browser-profile identifier for "this physical counter".
// Used only to scope which previous Evaluation Session a new document should
// cancel on the same workstation (see the backend's open_evaluation_session).
// Deliberately NOT per-tab (that's publisher.js's own randomId tabId, which
// exists purely for BroadcastChannel ownership arbitration) and NOT a device
// registry - V1 is exactly one random id generated once and kept in
// localStorage, nothing more.

const STORAGE_KEY = 'permtang.workstation_id';
let memoryFallback = '';

function randomId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback for a browser without crypto.randomUUID (older Safari).
  return 'ws-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
}

// Returns the same id for the life of this browser profile. Falls back to a
// stable in-memory id for this tab (never throws) if localStorage is blocked
// or unavailable (private browsing, blocked site data). Cross-reload
// persistence cannot be guaranteed in that environment, but add_document and
// get_or_create still use the same id during the current workflow.
export function getWorkstationId() {
  try {
    const existing = window.localStorage.getItem(STORAGE_KEY);
    if (existing) {
      memoryFallback = existing;
      return existing;
    }
    const created = memoryFallback || randomId();
    memoryFallback = created;
    window.localStorage.setItem(STORAGE_KEY, created);
    return created;
  } catch (error) {
    if (!memoryFallback) memoryFallback = randomId();
    return memoryFallback;
  }
}
